import MuiButton from "@material-ui/core/Button";
import React, { FC } from "react";
import { GridColDef } from "@material-ui/data-grid";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

import DataGrid from "../../../../components/redesign/modules/DataGrid";
import { FoundHubspotPage } from "../../../../types/campaignTypes";

type HubSpotPagesGridProps = {
  pages: FoundHubspotPage[];
  selectedUrl: string;
  onSelect: (url: string) => void;
};

const SelectButton = styled(MuiButton)(({ theme }: { theme: Theme }) => ({
  background: theme.palette.brand.white,
  color: theme.palette.brand.gray900,
  border: `1px solid ${theme.palette.brand.gray200}`,
  fontSize: 12,
  fontWeight: 600,
  padding: "4px 12px",
  borderRadius: 6,
  textTransform: "none",
  boxShadow: "none",
  minWidth: "unset",
  "&:hover": {
    background: theme.palette.brand.gray50,
  },
}));

const SelectedButton = styled(MuiButton)(({ theme }: { theme: Theme }) => ({
  background: theme.palette.brand.coral,
  color: theme.palette.brand.white,
  fontSize: 12,
  fontWeight: 600,
  padding: "4px 12px",
  borderRadius: 6,
  textTransform: "none",
  boxShadow: "none",
  minWidth: "unset",
  "&:hover": {
    background: theme.palette.brand.coralHover,
  },
}));

const UrlLink = styled("a")(({ theme }: { theme: Theme }) => ({
  color: theme.palette.brand.blueAccent,
  fontSize: 13,
  textDecoration: "none",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  display: "block",
  "&:hover": {
    textDecoration: "underline",
  },
}));

const UrlCell = ({ value }: { value: unknown }) => (
  <UrlLink href={value as string} target="_blank" rel="noopener noreferrer">
    {value as string}
  </UrlLink>
);

const HubSpotPagesGrid: FC<HubSpotPagesGridProps> = ({ pages, selectedUrl, onSelect }) => {
  const ActionCell = ({ value }: { value: unknown }) =>
    selectedUrl === value ? (
      <SelectedButton disableRipple>Selected</SelectedButton>
    ) : (
      <SelectButton onClick={() => onSelect(value as string)}>Select</SelectButton>
    );

  const columns: GridColDef[] = [
    { field: "name", headerName: "Name", width: 250, cellClassName: "primaryCell" },
    {
      field: "url",
      headerName: "URL",
      flex: 1,
      renderCell: UrlCell,
    },
    { field: "pageType", headerName: "Page Type", width: 120, cellClassName: "secondaryCell" },
    { field: "state", headerName: "State", width: 130, cellClassName: "secondaryCell" },
    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: ActionCell,
    },
  ];

  const rows = pages.map(({ id, name, url, pageType, state }) => ({
    id: id.toString(),
    name,
    url,
    pageType,
    state,
    action: url,
  }));

  return <DataGrid columns={columns} rows={rows} autoHeight />;
};

export default HubSpotPagesGrid;
